import React from "react";
import { connect } from "react-redux";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Input from "reactstrap/lib/Input";
import Table from "reactstrap/lib/Table";
import Button from "reactstrap/lib/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FindUserInfo from "../../components/UserManagement/FindUserInfo";
import AddUserAPLLicense from "../../components/UserManagement/AddUserAPLLicense";
import MoveUser from "../../components/UserManagement/MoveUser";
import DeleteResults from "../../components/UserManagement/DeleteResults";
import DeleteUser from "../../components/UserManagement/DeleteUser";
import RestoreDeleteStudentWithNoCLass from "../../components/UserManagement/RestoreDeleteStudentWithNoCLass";
import RestoreDeleteStudentWithNoCLassAndNoLicense from "../../components/UserManagement/RestoreDeleteStudentWithNoCLassAndNoLicense";
import CleanLicense from "../../components/UserManagement/CleanLicense";
import {
  fetchAdminUsers,
  deleteAdminUser,
} from "../../actions/adminUsersActions";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import CreateOrUpdateUserModal from "../../components/Modal/CreateOrUpdateUserModal";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      showConfirmDeleteDialog: false,
      userToDelete: null,
      showAddOrUpdateUserDialog: false,
      userToUpdate: null,
    };
  }

  componentDidMount() {
    this.updateUsers();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.adminUsers.result &&
      prevProps.adminUsers.result !== this.props.adminUsers.result
    ) {
      this.setState({ users: this.props.adminUsers.result });
    }
  }

  updateUsers() {
    this.props
      .dispatch(fetchAdminUsers())
      .then(() => {
        this.setState({ users: this.props.adminUsers.result });
      })
      .catch((err) => {
        console.warn("Unable to fetch administrators", err);
      });
  }

  toggleAddOrUpdateUserDialog = (user) => {
    this.setState({
      userToUpdate: user,
      showAddOrUpdateUserDialog: !this.state.showAddOrUpdateUserDialog,
    });
  };

  toggleDeleteUser = (user) => {
    this.setState({
      showConfirmDeleteDialog: true,
      userToDelete: user,
    });
  };

  deleteUser = () => {
    this.props
      .dispatch(deleteAdminUser(this.state.userToDelete.id))
      .then(() => {
        this.updateUsers();
        this.dismissConfirmDeleteDialog();
      })
      .catch((err) => {
        console.warn("det gick inte att ta bort användaren", err);
      });
  };

  dismissConfirmDeleteDialog = () => {
    this.setState({
      showConfirmDeleteDialog: false,
      userToDelete: null,
    });
  };

  filterByQuery = (event) => {
    let query = event.target.value.trim().toLowerCase();
    if (query) {
      let filteredUsers = this.props.adminUsers.result.filter((user) => {
        return (
          user.name.toLowerCase().indexOf(query) >= 0 ||
          user.email.toLowerCase().indexOf(query) >= 0
        );
      });

      this.setState({ users: filteredUsers });
    } else {
      this.setState({ users: this.props.adminUsers.result });
    }
  };

  render() {
    return (
      <div>
        <FindUserInfo />
        <DeleteUser />
        <RestoreDeleteStudentWithNoCLass />
        <RestoreDeleteStudentWithNoCLassAndNoLicense />
        <MoveUser />
        <DeleteResults />
        <CleanLicense />
        <AddUserAPLLicense />
        <div className="container-fluid admin-container">
          <Row className="search-row">
            <Col className="col-3">
              <Input
                className="search-input"
                placeholder="Sök admin-användare"
                onChange={(event) => this.filterByQuery(event)}
              />
            </Col>
            <Col className="offset-7 col-2">
              <Button
                color="primary"
                outline
                className="pull-right fa fa-plus"
                onClick={() => {
                  this.toggleAddOrUpdateUserDialog(null);
                }}
              >
                <FontAwesomeIcon icon="plus" />
              </Button>
            </Col>
          </Row>
          <Row>
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Användarnamn</th>
                  <th>E-post</th>
                  <th>Roll</th>
                </tr>
              </thead>
              <tbody>
                {this.state.users.map((user, index) => (
                  <tr key={index}>
                    <td className={user.deleted ? "text-deletion" : ""}>
                      {user.name}
                    </td>
                    <td className={user.deleted ? "text-deletion" : ""}>
                      {user.email}
                    </td>
                    <td className={user.deleted ? "text-deletion" : ""}>
                      {user.role}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Row>
        </div>

        <ConfirmDialog
          isOpen={this.state.showConfirmDeleteDialog}
          title="Ta bort användare"
          message={`Är du säker på att du vill ta bort användaren ${
            this.state.userToDelete ? this.state.userToDelete.name : ""
          }?`}
          toggle={this.dismissConfirmDeleteDialog}
          onProceed={this.deleteUser}
          danger={true}
        />

        <CreateOrUpdateUserModal
          toggle={this.toggleAddOrUpdateUserDialog}
          show={this.state.showAddOrUpdateUserDialog}
          user={this.state.userToUpdate}
          updateUsers={this.updateUsers}
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    adminUsers: store.adminUsersReducer,
  };
};

export default connect(mapStateToProps)(Users);
